export const SkillBottomPage = [
  {
    title: 'PHP',
    img: 'php',
    exp: '1 year',
  },
  {
    title: 'Laravel',
    img: 'laravel',
    exp: '6 months',
  },
  {
    title: 'MySQL',
    img: 'sql',
    exp: '1 year',
  },
];

export default SkillBottomPage;
